import { retrieveMemberSepcialists } from "../../../../../redux/admin-slices/member.slice";
import TablePagination from "../../../../../components/common/PaginationSkell";
import EntriesSelect from "../../../../../components/ui/EntriesSelect";
import Messages from "../../../../../components/common/messages/chat";
import TableSkell from "../../../../../components/common/TableSkell";
import useChatInitiater from "../../../../../hooks/useChatInitiater";
import InputFieldA from "../../../../../components/ui/InputFieldA";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "../../../../../utils/helper";
import { useState, useEffect, useRef } from "react";
import Icons from "../../../../../assets/js/Icons";
import { useParams } from "react-router-dom";

import {
  Avatar,
  Box,
  Grid2 as Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Collapse,
} from "@mui/material";

function Specialists() {
  const { userId } = useParams();
  const dispatch = useDispatch();
  const searchRef = useRef("");
  const statusRef = useRef("");
  const entriesRef = useRef("");
  const [data, setData] = useState(null);
  const { isActive, initiateGeneralChat } = useChatInitiater();
  const { loadings } = useSelector((state) => state.otherSlice);

  const handleRetrieveAll = (filters) => {
    dispatch(
      retrieveMemberSepcialists({
        userId: userId,
        search: searchRef?.current?.value || null,
        limit: entriesRef?.current?.value || null,
        currentPage: filters?.currentPage || null,
        status: statusRef?.current?.value?.value || null,
      })
    )
      .unwrap()
      .then((data) => {
        setData(data);
      })
      .catch(() => { });
  };

  const handleSearch = debounce(() => {
    handleRetrieveAll();
  }, 1000);

  useEffect(() => {
    handleRetrieveAll();
    // eslint-disable-next-line
  }, [userId]);

  return (
    <Box sx={{ mt: 3 }}>
      <Box
        sx={{
          p: 2,
          mb: 2,
          width: "100%",
          overflow: "hidden",
          borderRadius: "12px",
          bgcolor: "white",
          border: "1px solid #00000012",
        }}
      >
        <Grid
          container
          spacing={1}
          className="filters-grid"
          justifyContent="space-between"
        >
          <Grid size={{ xs: 12, lg: "auto" }} sx={{ minWidth: { xl: 350 } }}>
            <InputFieldA
              placeholder={"Search..."}
              label="Search by name or email"
              ref={searchRef}
              onChangeFun={handleSearch}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, lg: "auto" }}>
            <EntriesSelect
              inputRef={entriesRef}
              label="Entries per page"
              onChange={() => {
                setTimeout(() => {
                  handleRetrieveAll();
                }, 0);
              }}
            />
          </Grid>
        </Grid>

        <Grid mt={2} container spacing={3}>
          <Grid size={{ xs: 12, lg: "grow" }}>
            <Box className="content-listing">
              <TableContainer className="adminTable1">
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      {["Specialist", "Email", "Total Appointments", "Actions"]?.map(
                        (cell, i) => (
                          <TableCell key={i} align="left">
                            {cell}
                          </TableCell>
                        )
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loadings?.retrieveAll ? (
                      <TableSkell colLength={4} />
                    ) : (
                      data?.records?.map((member, i) => (
                        <TableRow
                          key={i}
                          tabIndex={-1}
                          role="checkbox"
                          sx={{
                            td: {
                              borderBottomWidth:
                                i === data?.records?.length - 1 ? "0" : "1px",
                            },
                          }}
                        >
                          <TableCell>
                            <Box
                              sx={{ display: "flex", alignItems: "center", gap: 1 }}
                            >
                              <Avatar
                                sx={{
                                  width: "21",
                                  height: "21",
                                }}
                                src={member?.specialistInfo?.image}
                              />
                              <Typography sx={{ textTransform: "capitalize" }}>
                                {member?.specialistInfo?.name}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell>{member?.specialistInfo?.email}</TableCell>
                          <TableCell>{member?.totalAppointments}</TableCell>
                          <TableCell>
                            {member?.hasChat && (
                              <IconButton
                                size="small"
                                title="Accept"
                                color="primary"
                                sx={{ p: 0.25, fontSize: 20, mr: 0.5 }}
                                onClick={() => {
                                  initiateGeneralChat({
                                    sender: userId,
                                    receiver: member?.specialistInfo?._id,
                                  })
                                }}
                              >
                                <Icons.ChatStrokeRounded />
                              </IconButton>
                            )}
                          </TableCell>
                        </TableRow>
                      ))
                    )}

                    {!data?.records?.length && !loadings?.retrieveAll && (
                      <TableRow sx={{ td: { borderBottom: "none" } }}>
                        <TableCell colSpan={4}>
                          <Typography variant="noRecords">
                            No Specialist found!
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                cb={handleRetrieveAll}
                pagination={data?.pagination}
                length={data?.records?.length}
                loading={loadings?.retrieveAll}
              />
            </Box>
          </Grid>
          <Grid size={{ xs: 12, lg: "auto" }}>
            <Collapse
              orientation="horizontal"
              in={isActive}
              timeout={300}
              unmountOnExit
            >
              <Messages />
            </Collapse>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default Specialists;
